import React from 'react';
import BaseButton from './BaseButton';
import Icon from '../icons/Icon';

const IconButton = React.forwardRef(({ icon, ...otherProps }, ref) => (
  <BaseButton ref={ref} {...otherProps}>
    <Icon icon={icon} />
  </BaseButton>
));

export default IconButton;
